export const DocumentSource = {
    CustomerReferenceData: {
        sourceId: 400,
        fileCode: 'customerreferencedata',
        sourceName: 'digitization_manual_customer_reference_data'
    },
    UnappliedCash: {
        sourceId: 300,
        fileCode: 'unappliedcash',
        sourceName: 'digitization_manual_unapplied_cash'
    },
    RemittanceAdvice: {
        sourceId: 88,
        fileCode: 'remittance-advice',
        sourceName: 'digitization_manual_remittance_advice'
    },
    CreditNote: {
        sourceId: 78,
        fileCode: 'creditnote',
        sourceName: 'digitization_manual_creditnote'
    },
    Invoice: {
        sourceId: 9,
        fileCode: 'invoice',
        sourceName: 'digitization_manual_invoice'
    },
    MultipleAsset: {
        // 9 hardcoded, need to be changed accroding to dource type
        sourceId: 9,
        fileCode: 'multiasset',
        sourceName: 'digitization_manual_multiasset'
    },
    Payment: {
        sourceId: 16,
        fileCode: 'payment',
        sourceName: 'digitization_manual_payment'
    },
    PurchaseOrder: {
        sourceId: 17,
        fileCode: 'purchase_order',
        sourceName: 'digitization_manual_purchase_order'
    },
    Policy: {
        sourceId: 11,
        fileCode: 'policy',
        sourceName: 'digitization_manual_policy'
    }
}